import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ManualsService } from "src/app/services/manuals/manuals.service";
@Component({
  selector: "app-menus",
  templateUrl: "./menus.component.html",
  styleUrls: ["./menus.component.css"],
})
export class MenusComponent implements OnInit {
  postObj: any;
  clientID: any;
  projectList: any;
  GetCustomersProjectList: any;
  constructor(private router: Router, private ManualsService: ManualsService) {}
  ngOnInit(): void {
    window.scrollTo(0, 0);
    // this.clientID = localStorage.getItem("user_id");
    this.clientID = localStorage.getItem("customerId");
    this.postObj = {
      customer_id: this.clientID,
    };
    this.ManualsService.getallprojectlist(this.postObj).subscribe(
      (res: any) => {
        if (res.code == 1) {
          this.projectList = res.data;
        } else {
          // this.flashMessage = "Something went wrong!";
          // this.flashType = "error";
          // this.flashActive = "flashblock";
        }
      }
    );
    //created the payload for the common api given by rajesh sir
    const payload={
        "modelName": "project_spare_list",
        "whereCondition":{
            "customerId":this.clientID
        },
        "relations": [
            {
                "module": "project",
                "moduleAs": "projects",
                "subModule": "department",
                "subModuleAs": "departments"
            }
        ]
    }
    this.ManualsService.GetCustomersProjectList(payload).subscribe(
      (res: any) => {
        // console.log("response --- " + res.response);
        if (res.code == 1) {
          this.GetCustomersProjectList = res.data;
        }
        // console.log(this.GetCustomersProjectList);
      }
    );
  }
  splitString(str: string, delimiter: string, index: number): string {
    const parts = str.split(delimiter);
    if (index < parts.length) {
      return parts[index];
    }
    return ""; // Return an empty string if the index is out of range
  }
  gotomanuals(projectId: any) {
    this.router.navigate(["/manuals/" + projectId]);
  }
  SparePartDetailsComponent(projectId: any) {
    this.router.navigate(["/SparePartDetailsComponent/" + projectId]);
  }
  redirectToPage(link: any) {
    this.router.navigate(["/" + link]);
  }
  // redirectToPage(link: any) {
  //   this.router.navigate(["/" + link]);
  // }
}
